import { Component } from 'react';
import LogUtil from '../../utils/LogUtil';

// 한 화면의 렌더 예외가 앱 전체 흰 화면이 되지 않게 막는다 (사이드바·헤더는 유지).
// MainLayout 에서 key={pathname} 으로 감싸서 다른 메뉴로 이동하면 초기화된다.
// shortcut: 안내 문구는 Figma 에 없는 임시 문구 — 디자인 확정 시 교체
export default class ScreenErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    LogUtil.error('[ScreenErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ padding: 40, color: '#71717a', fontSize: 'var(--text-14)', lineHeight: '20px' }}>
        화면을 표시하지 못했습니다. 새로고침하거나 다른 메뉴로 이동해 주세요.
      </div>
    );
  }
}
